import React, { useEffect, useState } from "react";
import { ListSubheader, MenuItem, Select } from "@mui/material";
import Button from "components/ui/Button";
import "./stylechild.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useSettingContext } from "context/SettingContext";
import { ReactComponent as NewRightsSearchIcon } from "assets/icons/NewRightsSearch.svg";
import { useLocation } from "react-router-dom";

function SelectRoleBtn({ name }) {
  const [selectValue, setSelectValue] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [open, setOpen] = useState(false);
  const searchInputRef = React.useRef(null);
  const [localSearch, setLocalSearch] = useState("");


  const {
    selectRoleBtnName,
    setSelectRoleBtnName,
    isRightPage,
    selectRoleOptions,
    setSelectRoleOptions,
    vibrateButton,
    setVibrateButton,
    selectUserBtnName,
    setSelectUserBtnName,
    setEnableSaveRightsBtn,
    searchTerm,
    setSearchTerm,
  } = useSettingContext();

  const originalRoleOptions = selectRoleOptions;

  const location = useLocation();

  const isRights = location?.pathname?.includes("new-rights")

  //------------------ Functions ------------------\\
  const handleChageFun = (e) => {
    const selectedRole = e.target.value;
    setVibrateButton(false);
    setEnableSaveRightsBtn(false);
    setSelectRoleBtnName(selectedRole);
    setSelectValue(selectedRole);

    let remainingRoles = originalRoleOptions.filter((role) => role.roleName !== selectedRole); //role.roleName
    setRoleList(remainingRoles);
    setLocalSearch("");
    setSearchTerm("");

  };


  useEffect(() => {
    setSelectRoleBtnName(selectRoleBtnName);
    setSelectValue(selectRoleBtnName);
    setRoleList(originalRoleOptions.filter((role) => role.roleName !== selectRoleBtnName));
    // setSearchTerm("");
  }, [name, selectRoleOptions]);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => searchInputRef.current?.focus(), 0);
    return () => clearTimeout(t);
  }, [open]);
  




  const creatBtnName = selectRoleBtnName;

  const filteredRoles = roleList?.filter((role) =>
    role.roleName.toLowerCase().includes(localSearch.toLowerCase())
  );

  return (
    <div className="child-header-create-btn">
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        fullWidth
        value={selectValue}
        onChange={(e) => handleChageFun(e)}
        displayEmpty
        className={vibrateButton ? "vibrate" : ""}
        renderValue={(selected) => {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span style={{ fontSize: "18px" }}>{selected === "" ? creatBtnName : selected}</span>
              <ExpandMoreIcon />
            </div>
          );
        }}
        onOpen={() => setOpen(true)}
        onClose={() => {
          setOpen(false);
          setLocalSearch("");
          setSearchTerm("");
        }}
        open={open}
        MenuProps={{
          disableAutoFocusItem: true,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "center"
          },
          PaperProps: {
            sx: {
              padding: "0px 5px",
              marginTop: "8px",
              backgroundColor: "#FFFFFF",
              color: "#000000",
              borderRadius: "5px",
              maxHeight: "180px",
              maxWidth: "400px",
              overflowX: "scroll",
              "&::-webkit-scrollbar": {
                width: "0px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "transparent",
              },
              scrollbarWidth: "none", // For Firefox
              "& .MuiList-root": {
                "& .MuiMenuItem-root": {
                  margin: "2px",
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  overflow: "visible",
                  whiteSpace: "normal",
                  paddingLeft: "10px",
                  paddingRight: "5px",

                  "&:hover": {
                    backgroundColor: "#444444",
                    color: "#FFFFFF",
                    borderRadius: "5px",
                    margin: "2px",
                    paddingLeft: "10px",
                    paddingRight: "5px",
                  },
                },
              },
            },
          },
        }}
        sx={{
          fontFamily: "karla",
          fontSize: "18px",
          lineHeight: "22px",
          fontWeight: 500,
          height: "41px",
          borderRadius: "5px",
          textTransform: "none",

          color: open ? "#000000" : "#FFFFFF", // Change text color based on open state
          backgroundColor: open ? "#FFFFFF" : "#000000",
          "&:hover": {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
          border: "1px solid #FFFFFF",

          // width: "200px",
          // width: "fit-content",
          minWidth:"200px",
          maxWidth:"fit-content",
          padding: "0px 10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          "& .MuiSelect-select": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: "10px !important",
          },
          "& .MuiSelect-icon": {
            display: "none",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&:focus": {
            backgroundColor: "transparent",
          },
        }}
      >
        {isRights && <ListSubheader
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 999,
            backgroundColor: "#FFFFFF",
            padding: "6px 3px 6px 3px !important",
            marginTop: "-8px !important",
          }}
        >
          <div
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            style={{
              width: "100%",
              height: "40px",
              display: "flex",
              alignItems: "center",
              padding: " 4px",
              borderRadius: "5px",
              backgroundColor: "#F2F2F2",

            }}
          >
            <NewRightsSearchIcon
              style={{
                width: "14px",
                height: "14px",
                flex: "0 0 auto",
                marginRight: "5px",
                marginLeft: "5px",
              }}
            />
            <input
              autoFocus
              ref={searchInputRef}
              value={localSearch}
              onChange={(e) => setLocalSearch(e.target.value)}
              placeholder="Search"
              onKeyDownCapture={(e) => {
                e.stopPropagation();
              }}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                backgroundColor: "transparent",
                fontSize: "12px",
                fontWeight: "500",
                fontFamily: "Poppins",
              }}
            /> 
          </div>
        </ListSubheader>}

        {filteredRoles?.map((item) => (
          <MenuItem
            key={item.roleName}
            value={item.roleName}
            sx={{
              fontSize: "18px",
              fontFamily: "karla",
              fontWeight: "400",
              justifyContent: "center", // Center content horizontally
              alignItems: "center", // Center content vertically
              textAlign: "center", // Center text
            }}
          >
            {item.roleName}
          </MenuItem>
        ))}

        {(!filteredRoles || filteredRoles.length === 0) && searchTerm.trim() !== "" && (
          <MenuItem disabled sx={{ opacity: 1, justifyContent: "center", fontFamily: "karla", fontSize: "14px" }}>
            No roles found
          </MenuItem>
        )}
      </Select>
    </div>
  );
}

export default SelectRoleBtn;
